<template>
  <div class="android-popup" :class="type">
    <h1 class="font-size-big">{{ title }}</h1>
    <h2 class="font-size-middle">{{ message }}</h2>
  </div>
</template>

<script>
export default {
  name: 'AndroidPopup',
  props: ['type', 'title', 'message']
}
</script>

<style lang="scss">
.android-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
  background: #000;

  &.success h1 {
    color: green;
  }

  &.error h1 {
    color: red;
  }

  h1 {
    margin-top: 150px;
  }

  h2 {
    font-weight: normal;
  }
}
</style>